import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e164c70"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Зачем учить три формы слова?", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Часто говорят, что эстонский очень сложный язык, поскольку здесь 14 падежей. На самом деле все не так плохо. У падежей своя логика, освоив которую вы сможете легко составлять пазл эстонского языка. А основой этого пазла являются первые три формы существительного (или первые три падежа). ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Давайте возьмем для примера два слова: sõber (друг) и raamat (книга).", -1))
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " У каждого падежа есть свои вопросы. Зачем вам их знать? Они помогут вам при выборе падежа. Когда вы будете учить глаголы, то следует обращать внимания на то, с какими вопросами они работают. Зная вопрос глагола вы сможете выбрать верную форму существительного или прилагательного. Например: tahtma, tahta, tahan (хотеть) работает с вопросом Keda? Mida? ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Посмотрите в таблице, какой падеж работает с вопросом Keda? Mida? Правильно! Osastav или третий падеж. Значит, если вам нужно сказать \"Я хочу эту книгу.\", то слова \"эту\" и \"книгу\" вы возьмете в третьем падеже: Ma tahan seda raamatut. ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Перед вами базовый пример того, как работают три формы.", -1))
const _hoisted_13 = ["src"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Если вы только начали изучать эстонский, то вам следует запомнить просто то, что: ", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ol", null, [
  /*#__PURE__*/_createElementVNode("li", null, " первую форму мы используем для слов, которые отвечают на вопросы Кто? Что? - See on raamat. (Это книга.); Menüü on luau peal. (Меню на столе.) "),
  /*#__PURE__*/_createElementVNode("li", null, " Вторую форму мы используем, если хотим выразить принадлежность - see on sõbra auto (это машина друга), õpetaja raamat (книга учителя), kohviku lahtiolekuajad (часы работы кафе). "),
  /*#__PURE__*/_createElementVNode("li", null, " Третью форму используем с числительными 2 и более - kolm kassi (три кота), viiskümmend külalist (50 гостей), kolm linna (три города). ")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " В данной таблице приведена общая логика использования первых трех падежей (или первых трех форм, как их часто называют). Вы сможете прочитать про каждый падеж отдельно, выбрав его в меню ", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = ["src"]
const _hoisted_21 = ["src"]

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CasesIntroduction',
  setup(__props) {

const isModalOpen = ref(false);
const modalImage = ref("");

function openModal(imageSrc: string) {
  modalImage.value = imageSrc;
  isModalOpen.value = true;
}

function closeModal() {
  isModalOpen.value = false;
  modalImage.value = "";
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("img", {
        src: require('@/assets/rulesImg/intro1.png'),
        class: "clickable-image",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (openModal(require('@/assets/rulesImg/intro1.png'))))
      }, null, 8, _hoisted_6),
      _hoisted_7,
      _hoisted_8,
      _hoisted_9,
      _hoisted_10,
      _hoisted_11,
      _hoisted_12,
      _createElementVNode("img", {
        src: require('@/assets/rulesImg/intro3.png'),
        class: "clickable-image",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (openModal(require('@/assets/rulesImg/intro3.png'))))
      }, null, 8, _hoisted_13),
      _hoisted_14,
      _hoisted_15,
      _hoisted_16,
      _hoisted_17,
      _hoisted_18,
      _hoisted_19,
      _createElementVNode("img", {
        src: require('@/assets/rulesImg/intro2.png'),
        class: "clickable-image",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (openModal(require('@/assets/rulesImg/intro2.png'))))
      }, null, 8, _hoisted_20)
    ]),
    (isModalOpen.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "modal-overlay",
          onClick: closeModal
        }, [
          _createElementVNode("div", {
            class: "modal-content",
            onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("button", {
              class: "close-btn",
              onClick: closeModal
            }, "X"),
            _createElementVNode("img", {
              src: modalImage.value,
              class: "modal-image"
            }, null, 8, _hoisted_21)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})